import * as firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/database'

// 避免 Firebase 重複初始化
if (!firebase.default.apps.length) {
  firebase.default.initializeApp({
    apiKey: 'AIzaSyBis-VCTtzmCHdx9iAk7MeteCesRFRx-gs',
    authDomain: 'gogoout-steven.firebaseapp.com',
    databaseURL: 'https://gogoout-steven.firebaseio.com',
    projectId: 'gogoout-steven',
    storageBucket: 'gogoout-steven.appspot.com',
    messagingSenderId: '289599701709',
    appId: '1:289599701709:web:f0459991892c86438b9f84',
    measurementId: 'G-35TV7WTTV3',
  })
}

export default firebase
